var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76.02 84.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#1d1d1b;}.cls-3{fill:#dadada;}.cls-4{fill:#009bdf;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Trondheim kommunev\xE5pen hvit boks") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Kommunev\\xE5pen"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.7,65.47h.08a9.76,9.76,0,0,1,3.89-3.09c3.62-2,8.76-2.79,10.21-7.2A26.25,26.25,0,0,0,52,50.81V28.15c.32,0,.71.3,1,.16,1.37-1.88,2.59-3.8,4-5.64a.29.29,0,0,0,.05-.21,20.09,20.09,0,0,0-2.79-1,15.9,15.9,0,0,0-.95,2.05c-.71-.1-1.45-.42-2.19-.6a.08.08,0,0,0-.05,0c0-.77.51-1.58.4-2.32l-.58-.18A16.35,16.35,0,0,0,49,20c-.29.63-.29,1.53-.55,2.25l-2.11-.4c0-.74.23-1.5.31-2.25a10.36,10.36,0,0,0-2.56-.48,12.55,12.55,0,0,0-.42,2.3.09.09,0,0,1-.06,0l-2.19-.24c-.13-.74.13-1.56,0-2.32a11.47,11.47,0,0,0-2.53-.13c-.13.18,0,.43-.11.61a9,9,0,0,1-.05,1.72H37.51v5.4h.4a49,49,0,0,1,12.71,1.69H37.51V65.22l.16.23a0,0,0,0,0,0,0m-.19-44.41h-.92c-.11-.74,0-1.53-.11-2.3a23,23,0,0,0-2.72.08l0,2.32-1.93.21c-.29-.68-.08-1.66-.45-2.29-.79.06-1.56.18-2.35.32-.13,0-.27,0-.34.1,0,.77.29,1.53.32,2.24l-.71.13L27,22.11s0,0-.08-.08c-.24-.69-.16-1.5-.56-2.11a18.9,18.9,0,0,0-2.66.68c.05.71.37,1.43.47,2.16l-1.82.5c-.05-.08-.08-.19-.13-.28-.13-.5-.34-1-.47-1.46-.05-.11-.05-.21-.18-.26a13.68,13.68,0,0,0-1.79.61,7,7,0,0,0-1.29.58c.82,1.61,1.93,3.11,2.88,4.67.31.42.45,1,1,1.32.29-.05.61-.16.9-.19l0,17.4c.1,2.82-.24,5.67.24,8.47a7.6,7.6,0,0,0,3.59,4.94c2.06,1,4.11,2,6.17,3a10,10,0,0,1,4.21,3.12V28.15H24.41a0,0,0,0,1,0-.05,36.92,36.92,0,0,1,4.17-.9c1.4-.24,2.74-.39,4.16-.53,1.22-.1,2.43-.18,3.64-.18.39,0,.76,0,1.13,0Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34,58.91a0,0,0,0,1,0,0s0-.11,0-.13.06,0,.08-.08c0-.21-.08-.5.08-.69a.68.68,0,0,1,.42-.42,4.6,4.6,0,0,1,.93-.13,1.5,1.5,0,0,1,.48,0c.08-.05,0-.13,0-.21s-.15,0-.23,0a.81.81,0,0,0-.45.06c-.05,0-.13,0-.21,0a2,2,0,0,0-.58.24c-.13,0-.21.13-.32.24s-.05.13-.08.19,0,0-.08.05h0l-.13.27c-.08.21,0,.4,0,.61l.05.05Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M37.78,63.78c2.79-2.77,7.06-3.69,10.57-5.65a.09.09,0,0,1,.05,0,1.48,1.48,0,0,0-.45-.47,13.61,13.61,0,0,0-8.78-3.24,8.31,8.31,0,0,0-.95,0,.57.57,0,0,0-.31,0l-1.24-.06c-.13.08-.26,0-.4,0a13.3,13.3,0,0,0-2.25.22,16.67,16.67,0,0,0-1.84.47c-.4.16-.82.34-1.24.5a8.38,8.38,0,0,0-1.24.68A13.13,13.13,0,0,0,27.6,57.8c-.13.06-.13.08-.16.16,2.69,1.45,5.62,2.77,8.28,4.27a9.87,9.87,0,0,1,2,1.59Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.7,61.57c.43,0,.71-.29,1-.35.19.21.45.16.68.19s.51-.1.74-.19a3.17,3.17,0,0,0,.74-.61c.11-.19.32-.13.48-.23.26.13.58-.11.82-.21a2.41,2.41,0,0,0,1.16-1.66,2.31,2.31,0,0,0-.69-2.09,5.11,5.11,0,0,0-2.45-1,8.5,8.5,0,0,0-1.37-.19c-1.93-.1-5.22.46-5.83,1.11-.26.11-.32.29-.47.5a3.27,3.27,0,0,0-.27,1.93,2.33,2.33,0,0,0,1.37,1.47,1.75,1.75,0,0,0,.64.13s.05.05.05.08,0,0,.05,0l.29.23c.23.08.42.21.68.29a1.49,1.49,0,0,0,1.34,0,2.23,2.23,0,0,0,.53.34c.13.16.32.08.47.16",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M37.78,61.39a1.33,1.33,0,0,0,.84-.39.49.49,0,0,1,.37.18,2.2,2.2,0,0,0,.82,0,1.72,1.72,0,0,0,1-.64.66.66,0,0,1,.43-.26A2,2,0,0,0,42.1,60a2.3,2.3,0,0,0,1-1.4,2.13,2.13,0,0,0-.53-1.93c-2-1.35-4.72-1.29-7-.95-1,.27-2.16.48-2.69,1.21a1.52,1.52,0,0,0-.42,1,2.06,2.06,0,0,0,.48,1.63.75.75,0,0,0,.16.19,3,3,0,0,0,1.21.56.52.52,0,0,1,.34.21l.18.13c.47.26,1.19.63,1.74.34,0-.05,0-.11.08-.11h.11c.08,0,.1.14.21.16s.34.16.47.29.21,0,.34.08",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.62,61A4,4,0,0,0,38.2,61a1.48,1.48,0,0,0,.42-.21l.18.13c.27,0,.48.21.76.09a2.16,2.16,0,0,0,1.08-.69.57.57,0,0,0,.47-.13l.18-.27c.21-.58.82-1.18.42-1.84a1,1,0,0,1-.08-.26,2.19,2.19,0,0,0-.66-.53A2,2,0,0,0,39.44,57l-.4-.45a3.12,3.12,0,0,0-2.13-.19,1.08,1.08,0,0,0-.63.53.35.35,0,0,1,0,.23.72.72,0,0,0-.37-.31.78.78,0,0,0-.46-.06,1.81,1.81,0,0,0-.88.17,2.4,2.4,0,0,0-1,.93,2,2,0,0,0,.16,1.58c.29.5.82.66,1.24.9.08.21.32.26.5.34a3,3,0,0,0,1.1.13l.27-.13a3.84,3.84,0,0,0,.76.35Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.62,60.75h0l.18-.18.71-.56c.08-.08.2,0,.34-.08S41,60,41,60c.26-.16.26-.53.47-.77,0,0-.05.05-.08.05a.06.06,0,0,1-.06-.05,1.58,1.58,0,0,0-.05-1.06s-.1,0-.1-.1l0-.08a3.52,3.52,0,0,0-.58-.31,1.91,1.91,0,0,0-1-.13s0,0-.05,0,0,0,0-.06.05-.1.1-.13a2.52,2.52,0,0,1,1.58.39,1.18,1.18,0,0,1,.39,1.14.22.22,0,0,1,0,.13c.13-.15.08-.42.05-.63,0,0,0-.08,0-.1s-.24-.24-.18-.43v0a2.07,2.07,0,0,0-1.84-.58.09.09,0,0,1-.08,0,.3.3,0,0,0-.11.26,5.41,5.41,0,0,1-.68,2.82l0,.08c.1.1.26.16.4.28s.37,0,.5.08",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.67,60.62a1.14,1.14,0,0,0,.87-.29l0-.24.16-.26a3.33,3.33,0,0,0,.4-1.24,4.1,4.1,0,0,0,.05-1.5c-.05-.08-.08-.24-.18-.27a3.07,3.07,0,0,0-1.88-.26,1.55,1.55,0,0,0-.31.1.85.85,0,0,0-.35.53,7.23,7.23,0,0,0,.08,1.48,2.71,2.71,0,0,0,.48,1.4h0a3.1,3.1,0,0,1,.11-.87s.1,0,.13,0l0,.29c.35.06.74-.1,1,.08a.1.1,0,0,0,0,.05.18.18,0,0,1-.13.1c-.23-.15-.53,0-.79-.05-.08,0-.1,0-.16,0-.1.19,0,.4,0,.61a.21.21,0,0,0,0,.14l.11.05,0-.47a.08.08,0,0,0,.05,0l0,0a.81.81,0,0,1,.06.5v0Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.07,60.54a1,1,0,0,0,.77-.27c.05,0,.11,0,.11.08a.28.28,0,0,0,0,.13H37a.12.12,0,0,1,0-.08,2.1,2.1,0,0,1-.45-.72.21.21,0,0,0-.24.05.35.35,0,0,1-.29.16s-.05,0-.08-.08l.45-.32s.05,0,.08,0l-.21-1.24h0c-.08,0-.16.13-.26.08s0-.1,0-.13a.93.93,0,0,1,.24-.16,2,2,0,0,0,0-.77c-.08-.08-.13-.16-.21-.19L36,57.06a1.72,1.72,0,0,0-1.61.16,1.58,1.58,0,0,0-.68.76,1.5,1.5,0,0,0,0,.77,1.61,1.61,0,0,0,.4.87.16.16,0,0,0,.11.05l.29.18c0-.05-.05-.08-.08-.13s0-.08.08-.1L35,60l0,.08s0,0,.06.06.18-.08.26,0a1.87,1.87,0,0,0,.79.37",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.78,60.51h.08l0-.31,0-.08s-.08,0-.08,0l-.05.21,0,.16Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.15,60.46a.17.17,0,0,0,.1-.16v-.23s0,0,0-.05l-.08.05s0,0,0,.08v.24l0,.05Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.23,60.36h0c.08,0,.1-.11.13-.18v0a.05.05,0,0,0-.05-.06s0,0,0,0l-.08.19v.06Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39,60.25c.08,0,.11-.1.16-.19a.1.1,0,0,1,0-.05.08.08,0,0,1-.05,0L39,60.2a.08.08,0,0,0,0,.05Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.52,60c.08-.11,0-.3,0-.42a.73.73,0,0,1-.11-.32l0,0-.08,0Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.55,59.93a.09.09,0,0,1,.05,0v-.16a.71.71,0,0,1-.24-.15.37.37,0,0,0-.16-.06.17.17,0,0,0,0,.16,2.27,2.27,0,0,0,.32.24",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.91,59.83h0c.06-.08.21-.16.16-.29a.49.49,0,0,0-.23.21v0l0,.08Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.71,59.44h0s0-.05.05-.05l-.05-.08-.21-.16a4.24,4.24,0,0,0,.53-.76,1,1,0,0,0-.55-.31h-.05s0,.08,0,.1.34.08.42.27-.29.37-.45.61l.06.1,0,.06,0,.08Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.93,59.38l.29-.11a.12.12,0,0,0,0-.13s0,0,0-.08V59l-.45-.58s-.05,0-.08,0,0,.13,0,.18l.45.53-.24.16s0,0-.05,0l0,.08Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.52,59.09h.08V59c0-.11-.18-.14-.26-.19h0s0,0,0,.08Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.65,59.07,38,59s0,0,.06-.08,0,0,0,0l-.4,0c-.05-.29.11-.66,0-1h-.05a3.67,3.67,0,0,0-.05,1V59s.05,0,.08,0",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.06,59l.08-.06s0,0,0-.05l.16-.08s0-.06,0-.08-.08,0-.13,0L35,58.9V59A.12.12,0,0,1,35,59Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.84,59h0a.09.09,0,0,0,0-.08,1.28,1.28,0,0,0-.46-.34h0a.13.13,0,0,0,0,.13l.42.28Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.69,58.91a3,3,0,0,1,.63-.35.08.08,0,0,0,0-.1c-.18,0-.37.13-.53.24s-.13.08-.15.13Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.66,58.56a.09.09,0,0,0,.05,0s0-.05,0-.08-.16-.16-.29-.11,0,.06,0,.08Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.77,58.17,36.2,58a.08.08,0,0,0,0-.1c-.16-.06-.29.1-.43.18s-.05,0-.05.08l0,.05Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.39,58.07,38.6,58a.09.09,0,0,0,0-.05l-.05-.08.24-.06s0,0,0-.08v0l-.77,0s0,.05,0,.08l.42,0s0,0,0,0l-.1,0a0,0,0,0,0,0,0l0,.08.05.06Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37,58h.26l.08-.08v-.08a.3.3,0,0,1,.21,0s0,0,0,0l0-.16h-.79s0,0,0,0,0,.05,0,.07.15,0,.21.06,0,0,0,.08L37,58Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.59,57.88a2.08,2.08,0,0,0,.95-1c.11-.5.24-1,.35-1.5H49c-.26.72-.34,1.58-.58,2.32Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.2,57.85l.66-.61s-.13-.05-.13-.13a4.69,4.69,0,0,0-.24-.9l-1,0,.37,1.48Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.22,57.53s0,0,0,0c.11-.42.21-.87.34-1.32l-.92,0-.23.71Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.51,57.32l-.18-.61-1.1-4.22h-.9a7.59,7.59,0,0,0,1,3.43,8.24,8.24,0,0,0,.95,1.19c.05.1.16.13.23.21",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.39,57.32l.24-.05,0,0a.05.05,0,0,0-.05,0h-.32a0,0,0,0,1,0,0v0c0,.06.08.06.13.08",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38,57.32l.4-.05s0-.06,0-.06l-.4,0s0,0-.05,0l.05.05",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.86,57.22h0l0-.26c0-.05-.1,0-.13,0l0,0,.16.24Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "28.21 57.12 29 56.53 28.76 55.53 27.79 55.56 28.18 57.14 28.21 57.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "47.44 56.74 47.44 56.72 47.76 55.45 47.73 55.42 46.91 55.45 46.72 56.24 47.41 56.74 47.44 56.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.91,56.56a2,2,0,0,0,.45-.5,6.26,6.26,0,0,0,.76-3.67h-.29c-.35,1.37-.66,2.8-.95,4.2Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "29.27 56.4 29.79 56.05 29.16 56 29.27 56.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.29,56.16a1.16,1.16,0,0,0,.11-.32h-.55Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "27.63 55.93 27.39 55 26.42 55.03 26.63 55.95 27.63 55.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.77,55.93l.87-.06a4.36,4.36,0,0,0,.24-1.05l-.92,0-.24,1a.06.06,0,0,0,.05.06",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "30.01 55.74 29.85 54.95 28.92 54.92 29.11 55.77 30.01 55.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "30.34 55.72 31.14 55.32 30.9 54.45 29.98 54.45 30.32 55.72 30.34 55.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.53,55.68l.92-.1.18-.74-1.06,0-.18.72s0,0,0,0Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.13,55.48a.08.08,0,0,0,.05,0l.27-1.08a3.22,3.22,0,0,0-.9,0l-.1.43v.05l-.06.32Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.5,55.29l-.21-.82h-1l.24.82c.29,0,.66,0,1,0",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32,54.79l-.82.08c-.08.05.06.24.08.32a5.37,5.37,0,0,0,.74-.39",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.94,55.19h0l.21-.87-.87,0a3.92,3.92,0,0,0-.23.82s0,0,0,0c.24.1.58-.06.84,0",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.85,55.16l.77,0,.26-.8a3.35,3.35,0,0,0-.87,0,2.14,2.14,0,0,0-.18.82Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.27,55l0-.26-.87-.06a6.77,6.77,0,0,0,.85.32",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "32.54 54.77 32.56 54.71 33.41 54.42 33.38 54.37 32.38 54.34 32.54 54.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "27.32 54.73 26.79 52.52 25.79 52.52 26.26 54.73 27.32 54.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.6,54.71l.95,0L29,52.6a6.21,6.21,0,0,0-1-.05,15.4,15.4,0,0,0,.58,2.16",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "32.25 54.66 31.77 52.68 30.71 52.63 31.22 54.63 32.25 54.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "42.56 54.34 42.53 54.37 42.5 54.45 42.53 54.47 43.19 54.66 43.24 54.66 43.35 54.34 42.56 54.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.69,54.58l.45-2s0,0,0,0l-1,0-.45,2a6.55,6.55,0,0,0,1,0Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48,54.58l1-.06.48-2.08s0,0,0,0l-.92,0L48,54.56Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.5,54.56h.73a17.24,17.24,0,0,0,.48-2l-.9,0a16.6,16.6,0,0,0-.42,1.87Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "34.36 54.31 33.96 52.66 33.17 52.63 33.54 54.48 34.36 54.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42,54.4h.08l.08-.24s0,0,0-.05a10.49,10.49,0,0,0,.32-1.42l-.74,0a8.12,8.12,0,0,0-.42,1.56Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.48,54.26l.84-.14-.42-1.45-.84,0a7.28,7.28,0,0,0,.4,1.61Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.84,54.24H41a9.68,9.68,0,0,0,.4-1.48h-.84a7.76,7.76,0,0,0-.32,1.37c.16.11.42.06.63.11",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "30.85 54.13 30.4 52.63 29.45 52.55 29.9 54.1 30.85 54.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "28.37 54.16 27.9 52.55 27.05 52.52 27.39 54.16 28.37 54.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "33.25 54.16 32.88 52.63 32.01 52.66 32.35 54.13 33.25 54.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.36,54.15h.5a9.48,9.48,0,0,0,.34-1.29v-.08l-.79,0a3.21,3.21,0,0,0-.24.85,1.13,1.13,0,0,0-.08.42Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M37.91,54.13l.87,0c.58-1.42.24-2.9.32-4.38V46.64A4.9,4.9,0,0,0,38,46.59a.1.1,0,0,0-.08,0,.32.32,0,0,0-.06.16c.48,1.27.76,2.74,1.16,4a1.51,1.51,0,0,1-1.08.58,1.63,1.63,0,0,1-.74-.13,1.52,1.52,0,0,1-.47-.34.38.38,0,0,1-.24-.24c.08-.42.21-.79.32-1.21.26-.79.47-1.69.71-2.51,0-.13.08-.29,0-.39s.05-.21.1-.32a.19.19,0,0,1,.16,0l.13.08,1.13,0a1,1,0,0,0,.06-.5,2.43,2.43,0,0,1,0-.42c0-.71,0-1.39,0-2.11,0-.95,0-1.92,0-2.87-.06-.45,0-.89-.06-1.29.06-.24,0-.5.06-.69a.89.89,0,0,1,.37-.63l.24-.18.32-.06c.1-.34-.06-.77.08-1.1.21-.08.52,0,.76,0,.42,0,.9-.13,1.26.05a.14.14,0,0,1,.11.16c0,.13,0,.26,0,.39a6.84,6.84,0,0,0,1.45,0c.1-.11,0-.29.05-.45a.32.32,0,0,1,.11-.22s.05,0,.05,0c.61.16,1.29,0,1.92.11.05,0,.13,0,.13.08s0,.37.08.5l.74,0,.92-.05v-.53c.23-.21.63-.08.94-.13s.87-.1,1.22.08h0a.13.13,0,0,1,.1.13A.75.75,0,0,0,50,37a4.87,4.87,0,0,0,1.05,0l0-8.18-6.59,0H24.27l0,8.68,4.4-.45.45-.69s0,0,.1-.05c.21.16.29.47.5.66a18.33,18.33,0,0,0,3.06-.4.2.2,0,0,0,.1-.1.35.35,0,0,0,.11-.29c0-.13.07-.26.07-.4l-.34-.05c0-.26.15-.53.08-.81l-.47.05-.37.11c-.08,0-.11-.06-.13-.13a2.19,2.19,0,0,1,0-.71.37.37,0,0,1,.16-.05,4.39,4.39,0,0,1,.66.13h0c.08-.29-.1-.61-.08-.9a.2.2,0,0,1,.16-.13,2.36,2.36,0,0,1,.66.08l0,.89c.23.08.45-.24.66-.13a.09.09,0,0,1,.05,0c.05,0,.08,0,.1.08v.63c-.24.19-.52,0-.79,0-.1.27.21.61.06.87l-.24,0v.71l.08.05,1.82,3.22c.05-.53,0-1.06,0-1.64a3.76,3.76,0,0,1,0-.55s-.08,0-.1,0-.06-.05-.08-.1c.11-.32.32-.56.42-.9.11-.11.16-.19.29-.16.24.21.29.45.5.63a26.83,26.83,0,0,1,.15,3.85l0,2.24v0l.06.11v0a0,0,0,0,0,.05,0,.21.21,0,0,1,.13.21s0,.08,0,.13l.13-.24a.09.09,0,0,1,.06,0l.15.42c.06.1,0,.26,0,.39s0,.42-.11.63a2.87,2.87,0,0,1-.18.71,2.42,2.42,0,0,0-.26,1.5c0,1.84,0,3.69.08,5.57.16.4.13.95.32,1.42.34.08.74,0,1.13.08",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.56,54.1l.9,0-.21-1.32-1-.08c0,.47.29,1,.31,1.42Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42.47,54.1l.71,0a8.18,8.18,0,0,0,.37-1.42l-.82,0-.34,1.37s.05.05.08.05",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.76,54.1l.71,0a9.14,9.14,0,0,0,.37-1.5,2.91,2.91,0,0,0-.82,0,6.32,6.32,0,0,0-.4,1.48Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.88,54l.37-1.53s0,0,0,0l-.82,0L47.06,54c.05.1.74,0,.82,0",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.2,54a12.51,12.51,0,0,0,.37-1.48c0-.08,0-.1,0-.16l-.82,0A8.16,8.16,0,0,0,49.33,54l0,0Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.41,52.55l1.21,0v-.61c-.13-.08-.29,0-.42,0a4.81,4.81,0,0,1-.84.05v.58Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "41.1 52.5 41.47 52.5 41.05 49.62 41.1 52.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.73,52.47l3.51-.13a8.66,8.66,0,0,0,.05-1.63,7.57,7.57,0,0,1,.08-1.3c0-.23.11-.48,0-.69,0,0,0-.1,0-.16s0,0,.08,0V48.3c-.19-.16-.5-.16-.74-.32s-.53,0-.69-.21c0,0,0,0,0-.05.11.9.58,1.88.66,2.8l0,.1c0,.11-.13.13-.18.21a1.55,1.55,0,0,1-1.42.48.71.71,0,0,0-.24-.08,1.31,1.31,0,0,1-.42-.31c-.08-.16-.21-.27-.16-.43a29.08,29.08,0,0,0,1.08-3.69c0-.08.05-.1,0-.13l-1.13-.06.11.69c.08.37.21.74.29,1,0,.11.08.19,0,.27l-.08,0a2.1,2.1,0,0,1-.32-.69A7.67,7.67,0,0,0,42,46.64l-.61,0a.07.07,0,0,0-.06.11c0,.84.16,1.66.27,2.51a0,0,0,1,1,0,0s0,.08,0,.08a4.93,4.93,0,0,0,.13.58A7.73,7.73,0,0,0,42,51c.16.26.16.63.4.84,0,.06,0,.06,0,.08l0,.1a.09.09,0,0,1-.05,0,.3.3,0,0,1-.21-.15,7.76,7.76,0,0,1-.55-1.45A16.11,16.11,0,0,1,41,46.77v-.06c-.05,0-.08,0-.08-.08a.15.15,0,0,0-.1,0c-.08.42,0,.9,0,1.32A6.86,6.86,0,0,1,41,49.18c.05.34.15.71.21,1l0,0a.34.34,0,0,1,0,.27c.05.21.05.5.11.71a.28.28,0,0,0,.08.13s0,.05,0,0c0,.16,0,.29,0,.44s.11.24.16.4Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.19,52.44h.24a21.51,21.51,0,0,0,.16-2.56c0-.13,0-.23-.06-.34s-.08-.13-.08-.21,0-.13,0-.15,0-.06,0-.06,0-.21-.05-.26,0,0,0,0c-.08.29,0,.58-.1.87a2.84,2.84,0,0,1-.11.68c-.19.66-.15,1.32-.34,2Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.06,52.44l.36,0a3,3,0,0,0,.37-1,14,14,0,0,0,.48-2.93s0,0,0,0c-.21.45-.21,1.08-.48,1.56s-.45,1.11-.63,1.63a3.41,3.41,0,0,0-.32.74,0,0,0,0,0,0,0Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.8,52.44l.31-.06c.06-.24-.1-.48-.05-.77-.08-.47-.11-.92-.21-1.37,0-.05-.08-.08-.13-.14-.08.14,0,.32,0,.46A11.18,11.18,0,0,0,35.8,52a.93.93,0,0,0-.08.23c0,.08,0,.11,0,.19s0,.06.08.06",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.16,52.41l.29,0a14.72,14.72,0,0,0,1.16-2.59c.27-.58.37-1.21.58-1.74v-.24s0-.06,0-.06l-.1-.74,0-.1a4.2,4.2,0,0,0-1,1c-.05.13-.08.27-.18.32a5.61,5.61,0,0,0-.31,1c-.05.35-.05.69-.13,1,0,.06-.08,0-.1,0a6.55,6.55,0,0,1,.13-1.45h-.05c-.05,0-.05.1-.08.14l-.06,0a5.58,5.58,0,0,1-.58,1.21c-.16.34-.31.71-.5,1,0,0,0,.08,0,.1l-.08.05a.05.05,0,0,1-.05-.05c.24-.79.71-1.45,1-2.21,0,0,0,0-.05,0l-.43.37,0,.08c0,.05-.1.05-.1.1s0,.06,0,.08c-.19.13-.27.37-.45.5-.15.29-.37.5-.5.79A7.91,7.91,0,0,0,31,52c.08.16-.08.26,0,.4l.82,0Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "24.47 52.23 28.63 52.36 28.84 52.34 28.84 51.87 24.49 51.73 24.47 52.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29,52.36h.58l0-3.46c0-2.95,0-5.88,0-8.83,0-.66-.1-1.77-.05-2.51l0,0-.58,0c-.13.13,0,.37-.06.56,0,.76,0,1.53,0,2.27,0,.47,0,1,0,1.45l0,3.66-.11,1L28.89,51a5,5,0,0,0,0,1.27l.05,0",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.1,52.36h.66A2.14,2.14,0,0,1,31,51.6a1.89,1.89,0,0,1,.19-.47,2.83,2.83,0,0,0-.69.61s0,.08-.05.08l-.39.32s0,.08,0,.1l-.05.08s.05,0,.08,0",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "45.67 52.34 45.7 52.34 45.88 52.31 45.7 50.73 45.67 52.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46,52.31l.43,0a1.92,1.92,0,0,1,.15-.45,6.42,6.42,0,0,1,.27-1c0-.1,0-.21.1-.31a5.18,5.18,0,0,0,.24-1.9c.05-.13,0-.24,0-.34a2,2,0,0,0-.13-.32c-.18-.13-.4-.1-.61-.18H46.4a6,6,0,0,1-.29,2.54.9.9,0,0,1-.1.47H46a.11.11,0,0,1-.1-.1L46,50c-.32-.44,0-1.11-.32-1.58h0a9.91,9.91,0,0,0-.05,1.24A21.71,21.71,0,0,0,45.9,52c.05.11,0,.21.05.3Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.93,52.29l1,0a15.7,15.7,0,0,0-.42-2.93s0,0,.06-.05a.15.15,0,0,0,0-.1.13.13,0,0,0-.13,0,1.41,1.41,0,0,1-.08.43,4.8,4.8,0,0,1-.16,1.05,8.12,8.12,0,0,1-.39,1.32v0s0,0,.08,0l0,.08a.23.23,0,0,0,0,.19Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M48.25,52.23l.24,0c.06-.26,0-.55,0-.84s0-.87,0-1.27c0,0-.08,0-.11,0a1.4,1.4,0,0,1-.42.56l.19,1.5s.05.05.08.05",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.83,52.2l2.27-.13,0-.24c-.16,0-.31,0-.47,0a12.13,12.13,0,0,1-1.4,0c-.18.05-.31,0-.47.05v.34Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29.92,52A12.55,12.55,0,0,0,31,50.92c.05,0,.05-.08.08-.08.27-.34.64-.71.9-1.05a7.16,7.16,0,0,0,1.05-2,3.82,3.82,0,0,1,.19-.5l-.19,0a1.13,1.13,0,0,1-.21.53c-.16.34-.34.63-.52,1a10.51,10.51,0,0,1-2.46,2.37,3,3,0,0,0,0,.81Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.39,51.65l.56,0,0-.71c-.16-.11-.4,0-.58,0v.68s0,0,.05,0",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.26,51.65h.34a2.52,2.52,0,0,0,0-.77h-.36a1.37,1.37,0,0,0,0,.77Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "27.16 51.57 28.84 51.55 28.84 50.86 25.84 50.88 25.84 51.57 27.16 51.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "24.49 50.88 24.49 51.55 24.52 51.55 25.58 51.55 25.58 50.88 24.49 50.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.85,51.55l1,0c.08-.13,0-.37,0-.55s0-.08,0-.13a3.59,3.59,0,0,0-1.05,0c-.11.21,0,.47,0,.71,0,0,.08.05.1.05",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51.1,51.52l0-.71a5.9,5.9,0,0,0-.95,0c-.1.21,0,.45,0,.69a5.73,5.73,0,0,0,.95,0",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.83,51.18a1.16,1.16,0,0,0,.63-.21l-1.24,0a1,1,0,0,0,.61.18",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.39,51.13a1.13,1.13,0,0,0,.76-.27c-.42,0-.9.06-1.34,0,0,0,0,0,0,.05s.37.19.61.24",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.17,51l0-3.37a12.56,12.56,0,0,0-.29,1.4c.05.23.08.5.13.74A10.4,10.4,0,0,1,36.17,51",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29.87,51l0,0c.19-.13.4-.32.61-.45a7.53,7.53,0,0,0,2.35-3.22c-.24-.08-.47-.11-.74-.21S31.9,47,31.74,47a3.49,3.49,0,0,1-1.11-.77c-.21.13-.24.37-.4.53s-.16.39-.39.44v.77s0,0,0,0a1.27,1.27,0,0,1,.21-.5.18.18,0,0,1,.1-.11l.08,0a8.33,8.33,0,0,0-.32,1c.29-.29.4-.68.74-1a.19.19,0,0,1,.11-.1h0s.05-.11.13-.11,0,0,0,0l-.27.4A6,6,0,0,0,29.92,49s0,0-.05.08l0,.5s.1-.11.13-.16a10.57,10.57,0,0,1,.85-1.35,1.6,1.6,0,0,0,.29-.32s0,0,.06,0l.13-.08,0,0,0,0a.09.09,0,0,1,0,.05s0,0,0,0a7.65,7.65,0,0,1-.63.9,6.52,6.52,0,0,0-.71,1.27c0,.07-.08.07-.08.13l0,.16c.42-.34.79-1,1.32-1.24l.15-.19a3.14,3.14,0,0,0,.87-1.06l.24-.1c0,.24-.24.42-.34.63a2.55,2.55,0,0,1-.26.26c-.13.27-.5.48-.66.71s-.29.32-.48.42-.4.32-.5.53l-.37.4Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.78,50.81l.87-.05c-.05,0-.08-.11-.08-.11l-1.5,0s-.1.08-.08.11Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.3,50.65l2.16,0c.11-.21,0-.47,0-.68l-2.21-.08v.79Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.18,50.65a4.81,4.81,0,0,0,.61,0h.34c.08,0,.26-.13.1-.13a10.17,10.17,0,0,0-1.58,0l.14.16Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.39,50.62l1.21,0a5.23,5.23,0,0,0,0-.82,4.72,4.72,0,0,0-1.26,0l0,.89Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "28.82 50.6 28.82 49.94 27 49.88 26.97 50.62 28.82 50.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.07,50.54l2,0,0-.8a18.4,18.4,0,0,0-2.37,0,2.52,2.52,0,0,0,0,.79Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M36.81,50.49l.74-.08a26.84,26.84,0,0,0,.08-2.88l-.84,3Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38.55,50.49h.16a29,29,0,0,0-.82-3c-.08.95-.05,2-.08,2.93.21.13.5,0,.74.1",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.93,50.44a2,2,0,0,0,.55-.84c-.05-1,.24-2.22-.24-3.11a3.71,3.71,0,0,0-.84-1.08c-.08.16-.14.32-.21.44a13.58,13.58,0,0,1-.9,1.48c-.05.07-.1.07-.13.13.13.1.34,0,.5.12a2.08,2.08,0,0,0,.37.06c0-.08-.08-.18-.11-.29a.47.47,0,0,1-.18-.47l.06-.06s0,0,.05,0a4.93,4.93,0,0,1,.42.71c.19-.21.14-.61.4-.76a.09.09,0,0,1,.08.08l-.24.68.13,0c.11,0,.19.11.37.11,0,.05,0,.05.08.1a.12.12,0,0,1,0,.16,0,0,0,0,1,0,0,.75.75,0,0,0-.37-.14.08.08,0,0,1,0,0l-.13.08,0,.08c.19,0,.24.16.37.26.13.27.4.48.34.82a.35.35,0,0,1-.08.1c-.08,0-.11-.13-.11-.21a2.82,2.82,0,0,0-.39-.58c-.05-.08-.13-.13-.18-.1s0,0,0,.05Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42.6,50.39l.84-.08a17.15,17.15,0,0,0,0-2.63,7.39,7.39,0,0,0-.36,1c-.16.58-.37,1.14-.53,1.72Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.29,50.34h.08c.08-.19-.08-.46-.08-.66-.18-.66-.32-1.29-.53-1.93h0l0,2.48c.13.11.37,0,.53.11",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.6,49.65l0-.77a27.47,27.47,0,0,0-2.9,0l0,.79Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "24.49 49.65 25.6 49.65 25.65 48.86 24.49 48.86 24.47 49.65 24.49 49.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.36,49.46h.5a2.47,2.47,0,0,0,.05-.77c-.16-.08-.4,0-.56-.05Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.2,49.46h.36a4,4,0,0,0,0-.79h-.36a1.51,1.51,0,0,0,0,.79",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.91,49.46l.89,0,0-.79a4.68,4.68,0,0,0-1.08,0l0,.79c.05.05.13,0,.19.05",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.12,49.44l1,0,0-.77-1,0a2.37,2.37,0,0,0-.05.81",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.13,49.33a1.13,1.13,0,0,0,.09-.34c0-.08.05-.13,0-.19L46,48.72s0,0,0,0l0,.53s0,0,.05,0l.05.11Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.82,49c.13-.06.24-.24.42-.29a1.25,1.25,0,0,0,.45-1.21c0-.08,0-.13,0-.18s-.08,0-.13,0c-.16.18-.16.5-.27.68a3.87,3.87,0,0,1-.47,1Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.3,48.62h1.13c.13-.18,0-.5.05-.74a.33.33,0,0,0,0-.11H24.25l0,.82Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "28.79 48.62 28.82 47.83 26.95 47.8 27 48.62 28.79 48.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.24,48.51h0a1,1,0,0,0-.16-.79,3,3,0,0,1-.61-.37,2.81,2.81,0,0,0-.66-.4s.06.05.08.11l0,.08c-.27,0-.53-.16-.79-.11H44a.14.14,0,0,1-.08-.13s0-.08.08-.08l.11-.05s.05-.1.1-.1c.63-.16,1.06.31,1.53.55.19-.13.24-.34.42-.5,0-.05,0-.05,0-.08a2.17,2.17,0,0,0,.45-1.24.92.92,0,0,0-.21-.58c-.08-.08-.11-.16-.16-.18s-.08,0-.11,0l.09.39a.39.39,0,0,0,0,.19,2.51,2.51,0,0,0-.08.29,1.75,1.75,0,0,1-.53.79.38.38,0,0,0-.1.08l-.42.23-.08,0v-.05c.11-.16.34-.19.5-.34a.84.84,0,0,0,.32-.37c-.11,0-.13.19-.29.19s-.34.11-.53.18c0,0,0,0-.05,0s-.23,0-.37-.08-.16-.13-.18-.18,0-.1.08-.1.15.05.21.13l.15.08c.19-.05.45,0,.55-.19A1.21,1.21,0,0,0,45.9,45a1,1,0,0,0,0-.48.31.31,0,0,1-.08-.23,0,0,0,0,0-.06,0c0,.19-.16.32-.13.48l-.13.08a.26.26,0,0,1-.18.18l-.24.11c-.06,0-.06,0-.08,0s-.08,0-.08-.08,0-.1.08-.13a.71.71,0,0,0,.48-.39,1.2,1.2,0,0,0-.08-.69l.06-.11s0,0,0,0-.15.08-.18.19v0l-.29.22a2.49,2.49,0,0,1-.87-.11C44,44,44,44,44,44s-.08.31-.08.47.19.29.26.45.32.1.37.29v0c0,.05-.05.09-.11.11s-.42-.11-.55-.32-.08-.13-.11-.21a2.53,2.53,0,0,0-.11-.3c-.19.11-.1.4-.13.58a1.76,1.76,0,0,0,.61,1v.1c-.13,0-.24-.1-.32-.15a4.42,4.42,0,0,1-.47-.74c0-.08-.11-.18-.05-.27l.08-.05v-.23a0,0,0,0,0,0,0,.11.11,0,0,1-.11-.06,1.43,1.43,0,0,0,0,1.08.44.44,0,0,1,.16.23l0,.08a.18.18,0,0,1-.16,0c-.18-.11-.16-.32-.26-.45a3.22,3.22,0,0,1,0-.73c-.08,0-.16.1-.21.15,0,.27-.06.56.1.79,0,.08,0,.13,0,.16a.09.09,0,0,1-.08,0c-.13-.05-.16-.21-.18-.34s0-.19,0-.29h-.06l-.16.26.18.29a.69.69,0,0,0,.11.32.08.08,0,0,0,.05,0h.85s.08-.13.15-.16l.11,0c.05.11.16.23.11.37s-.08.11-.11.13l.16.71a.08.08,0,0,0,.05,0l-.08-.16.08-.08a1.11,1.11,0,0,1,.66.16.11.11,0,0,1,0,.13s0,0,0,0,.11,0,.13.1,0,.11-.08.11l-.19,0s0,0,0-.06l-.29,0s-.05,0,0,0c.53.21,1.21.21,1.58.61.18.1.32.21.5.31Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.57,48.41h0l0-.71-1.23,0v.68c.13.09.37,0,.56,0a4.7,4.7,0,0,1,.67,0",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.67,48.38c.18-.76.37-1.53.5-2.29l.1-.5c.32-.24.29-.71.42-1.11a3.31,3.31,0,0,0,.06-.71H36.7l-.13.48a.08.08,0,0,0,0,0l-.06.05-.05.08s0,0,0,0l.05-.58-.1.37-.08,0c-.08-.24.11-.5.06-.79l-.13.4s-.05,0-.08,0l-.06.32s0,0-.05,0S36,44,36,43.94s.13-.24.08-.34c-.26.42-.08,1-.24,1.45a4.44,4.44,0,0,1-.37,1.06.56.56,0,0,0-.13.08.49.49,0,0,0-.05.18l0,.32.05.05c-.05.29.11.56,0,.87a3.87,3.87,0,0,0,.29.76Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.8,48.38H51.1l0-.71-2.37,0a1.55,1.55,0,0,0,0,.71Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.88,47.75l.31-.39a4.23,4.23,0,0,0-.52-1.09l.18,1.48Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "25.63 47.51 25.65 46.67 24.49 46.72 24.47 47.51 25.63 47.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "28.79 47.51 28.82 46.72 28.79 46.69 25.91 46.67 25.91 47.51 28.79 47.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.34,47.43l.56,0,0-.73s0-.06,0-.06h-.56Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.57,47.4h0l0-.73c-.1-.11-.29,0-.39-.08l0,.77Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.37,47.4s0,0,.05,0l.08,0a.25.25,0,0,0-.29,0v0a.32.32,0,0,0,.16,0",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.85,47.38h1l0,0,0-.72-1.16-.05v.74c0,.05.1,0,.15.05",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.36,47.38l.74,0,0-.68a3.75,3.75,0,0,0-1-.06c-.1.21,0,.48,0,.72Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.35,47.22l.13-.13c0-.21-.21-.29-.32-.45a1.57,1.57,0,0,1-.16-.15l.32.71a0,0,0,0,1,0,0",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.08,47.16l.11,0,.21-.29-.27.13-.08.16a0,0,0,0,0,0,0",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.24,47.11h0c0-.05.06,0,0-.05a9,9,0,0,1-1.08-.39c-.16,0-.24-.13-.42-.16A5.45,5.45,0,0,1,31,46c-.06,0-.06,0-.06,0a4.44,4.44,0,0,0,2.32,1.06",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.53,47s0-.08,0-.08l-.24-.16h-.13s0,0-.05,0a5.55,5.55,0,0,1-2.3-1.56.38.38,0,0,0-.35,0v0c.08.16.21.26.29.42a13.28,13.28,0,0,0,1.11.74,5.76,5.76,0,0,0,1.14.42c.13,0,.21.08.32.11l.1-.06s0,0,.05,0l.08.13Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M34.64,46.93a2.06,2.06,0,0,0,.52-.81,7.08,7.08,0,0,0,0-1.08l-.63,1.77.05.13Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.53,46.9h.08v0h-.1a0,0,0,0,0,0,0",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M29.87,46.72l.08,0c.18-.18.27-.45.45-.66h.05l0-.12s0,0-.06,0a1.21,1.21,0,0,1-.13-.9c.1-.13.31-.13.47-.13,0,0,0,0,0-.05a4.35,4.35,0,0,0-.63-.95,1.53,1.53,0,0,1-.26-.45,8,8,0,0,0,0,1.47l0,1.85Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M33.48,46.67l0,0a2,2,0,0,0-.37-1.1.11.11,0,0,1,0-.08l.05,0c.24.24.37.61.74.77.13.08.16.19.24.26l.61-1.68a.32.32,0,0,0-.1-.08.29.29,0,0,1,0-.21c.05-.1.21-.08.29-.19.11-.28.18-.58.29-.89s.18-.48.1-.69a.8.8,0,0,0-.29-.45.56.56,0,0,0-.69.08.8.8,0,0,0-.16.63c.06.19.18.24.34.32l.24-.05v0a.43.43,0,0,1-.31-.24,1,1,0,0,1,0-.26.39.39,0,0,1,.29-.13.52.52,0,0,1,.27.32c.08.11,0,.24.05.34a.68.68,0,0,1-.34.37.61.61,0,0,1-.61-.08,1,1,0,0,1-.39-.79.94.94,0,0,1,.37-.66,1.23,1.23,0,0,0,.34-.26,1.36,1.36,0,0,0,.31-.05l.34,0a.05.05,0,0,0,.05-.05V41.6a9.27,9.27,0,0,0-2.45-.12,1.37,1.37,0,0,1,.45,1c-.1.26.08.48,0,.74s.18.32.24.5l.13.37c0,.08-.05.11-.13.11s-.13,0-.18,0l-.05.58-.11.37-.1.13s-.11,0-.18,0c-.16.24,0,.53,0,.77l-.08.1a.5.5,0,0,0,.37.19l-.16-.71c0-.06.08-.08.11-.06h.08l.16.82Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "24.54 46.43 26.65 46.43 26.65 45.63 24.49 45.63 24.47 46.43 24.54 46.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "28.76 46.43 28.79 45.66 26.91 45.63 26.95 46.43 28.76 46.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M48.46,46.38c0-1.13,0-2.25-.05-3.38-.08-.19,0-.35-.14-.53a2.57,2.57,0,0,0-.24-.61A4.9,4.9,0,0,0,46.9,40.4a10.38,10.38,0,0,0-1.26-.61c-.16,0-.37-.11-.53-.11a.67.67,0,0,0-.45,0l-.16-.05h-.08a4.66,4.66,0,0,0-.95.26,4.42,4.42,0,0,0-2.32,1.93c-.1.26-.31.47-.31.76,0,0,.1.08.16.06a.49.49,0,0,1,.47.23,6.41,6.41,0,0,1,.37,1.58l-.05.07s.08.06.1.11.06.23.08.37a1.83,1.83,0,0,0,.18.37.09.09,0,0,0,.05,0l.1-.08a2.29,2.29,0,0,1,.53-.61c.27-.26.69-.47.87-.76l.05-.05-.29-.08c-.1,0-.1-.13-.18-.21a1.82,1.82,0,0,1,0-.77c.16-.39,0-.79.1-1.18,0,0,0,0,0-.06l-.61-.86-.08-.27a.26.26,0,0,1,.13-.18,3.8,3.8,0,0,1,.82.39c0,.06,0,.08,0,.13l.45,0c0-.05-.05-.08-.05-.14L44,40.5l.37-.55.18-.08c.21.11.24.37.43.5,0,.05,0,.08.05.1a.11.11,0,0,1-.11.11v.13l.42.1,0-.13c.18-.21.55-.18.79-.36a.13.13,0,0,1,.1.08,4.3,4.3,0,0,1-.47,1,1.34,1.34,0,0,1-.08.14,1.38,1.38,0,0,1,.21.87c0,.28.27.44.16.73a1.3,1.3,0,0,1-.05.19,1.75,1.75,0,0,0-.21.22.18.18,0,0,0-.16.1v0c.11.08.24.16.26.32a3,3,0,0,1,.58.29,13.51,13.51,0,0,1,1.17,1c.29.34.45.71.73,1.08Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.34,46.35h1.21a2,2,0,0,0,0-.66,9.94,9.94,0,0,0-1.23-.05,2.12,2.12,0,0,0,0,.69Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.36,46.35l.5,0a5.66,5.66,0,0,0-.21-1.45,3.39,3.39,0,0,0-.29,1.45Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.72,46.32l.21-.32.22-.63.05-.05a.26.26,0,0,0,.05-.11c-.13-.26-.4-.34-.61-.5,0,0-.05,0-.08-.08h0c.11.18.18.29.27.44a3,3,0,0,1-.14,1.24h.08Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49,46.35l2.11,0,0-.66-2.4,0a1.76,1.76,0,0,0,0,.66Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.91,46.32h0l.05-.13.11,0a1.4,1.4,0,0,0,.05-.74c-.05,0-.05,0-.08.05l0-.24a0,0,0,0,0,0,0,.24.24,0,0,0,0-.19v-.28c-.13.31,0,.68-.16,1a5.13,5.13,0,0,0,0,.61Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42.21,46.32h.1c0-.08-.1-.13-.15-.19s0,.1,0,.19Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.53,46.22h0l-.08-.71-.71-.37-.24-.4c-.05,0,0,.05-.08.08s0-.08-.05-.11-.11,0-.13,0a.15.15,0,0,0,0,.1l0,0-.05.37a3.78,3.78,0,0,0,1.34,1",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42.23,46v0a.11.11,0,0,0-.05-.11s0,.08,0,.11a.07.07,0,0,1,0,0Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42.1,45.72s0,0,.06,0,0,0,0,0l-.08-.05h0a.19.19,0,0,0,0,.11Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.92,45.56l0,0s0,0,.06-.08,0,0,0,0h-.05s0,.05-.05.08a.06.06,0,0,0,.05.05",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.46,45.51a1.25,1.25,0,0,0,.16-.53A4.28,4.28,0,0,1,36,43.24c.27-.42.11-1,.13-1.45l-.58-.13c-.08.1,0,.26-.05.39.34.21.18.73.42,1a.38.38,0,0,1,0,.16c0,.05-.05.08-.1.08l-.19.29a2.93,2.93,0,0,1-.18.63,1.19,1.19,0,0,0-.08.18s0,0,.08.05l.08.21a2,2,0,0,0-.05.87Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "28.76 45.37 28.82 44.63 25.84 44.63 25.84 45.37 28.76 45.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "24.49 45.35 25.54 45.38 25.58 44.66 24.49 44.63 24.49 45.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.52,45.4s0,0,0,0l0-.74-.4,0a6.71,6.71,0,0,0,0,.71.08.08,0,0,0,.05,0Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.34,45.37h.53l.05-.69a1.15,1.15,0,0,0-.61-.05v.74Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.72,45.37h1.05c.13-.21,0-.53,0-.77H48.72a1.57,1.57,0,0,0,0,.74Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.17,45.37h.92l0-.77h-1c-.11.21,0,.47,0,.72,0,0,0,0,.08,0",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.35,45.19h.34c0-.05.08,0,.13,0s0,0,0-.06l.06,0,.08-.26-.26,0s-.08-.06-.08-.08l0-.08.29,0a.34.34,0,0,0,0-.34s0-.05-.05-.08,0,0,0-.06l.31-.08L33,43.32c-.13-.05-.26,0-.4,0s-.24.08-.29.13-.08,0-.1-.08.05-.11.13-.13a4,4,0,0,1,.61-.19v-.32c-.13-.1-.34,0-.53.06a3.69,3.69,0,0,1-.58.23l-.08.42-.08,0-.08.37-.06,0-.13-.08s0,0-.06,0a.24.24,0,0,0,0,.26c.06.08.13.11.18.18l.16,0,.06.08-.08.1-.05.08c.21.16.19.5.53.53l.21.05",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.81,45l.15-.53c0-.05-.1-.11-.15-.11Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.36,45a.79.79,0,0,0,.15-.43v-.08l0-.11s0,0,0,0c0-.26-.13-.52-.13-.82a3.07,3.07,0,0,0-.16-.55l-.16-.08c-.08.1.11.21.14.31s-.14.32-.05.45.08.05.08.1,0,.08-.08.08h0c-.11,0-.18-.16-.22-.29v-.05a.82.82,0,0,1-.31-.37s0,0,0,0l.15.29c0,.05.11.1.13.19s0,0,0,.08-.24-.19-.31-.32l.18.4-.05.08v.05a.42.42,0,0,0,.16.11.2.2,0,0,1,.19.13,2,2,0,0,1,.24.58.93.93,0,0,1,.11.24",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31,44.58H31l.08-.06.11,0a.1.1,0,0,0,.1-.06c0-.1-.13-.16-.13-.29a.55.55,0,0,1-.08-.53c.08-.16.21-.19.37-.24l.05-.13.08-.05s0-.05,0-.05a3.31,3.31,0,0,0-1.09.63.52.52,0,0,0,.13.19l0,.16.11.29Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.5,44.45l0,0,0-.21-.18-.58H39.34a3.29,3.29,0,0,0,0,.71c.37.13.79,0,1.19.11",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "26.63 44.37 26.7 43.69 24.49 43.63 24.46 44.37 26.63 44.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.6,44.32v-.79c-.1.06-.05.11,0,.11a1.5,1.5,0,0,1-.52,0l-1.35.05,0,.63Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.72,44.34H51.1l0-.73h-2.4a1.55,1.55,0,0,0,0,.73Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.71,44.08h0V44s0,0-.08,0l0,.1Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.5,43.94l.47-.05c.06,0,0-.08.06-.13s0,0,.05-.05.21-.23.37-.16l.08-.05c.11,0,.13-.13.23-.13a.39.39,0,0,0,.16-.36.94.94,0,0,0-.13-.29,1.18,1.18,0,0,1,0-.53c0-.05-.05-.08-.05-.1-.08.29.11.66-.08.93a.44.44,0,0,1-.13.36h0c-.16-.34.13-.71,0-1l-.08,0c-.18-.16-.42,0-.63-.08,0,0-.05,0-.05-.08a.11.11,0,0,1,.1-.1,1.11,1.11,0,0,1,.66,0,.66.66,0,0,0-.05-.44,3.56,3.56,0,0,0-1.19-.06.75.75,0,0,0-.55.08.5.5,0,0,0,.08.39,1,1,0,0,1,.56.05s.16.08.16.13l0,.61c0,.08.13,0,.18.05a.13.13,0,0,1,.06.08v.05c-.08.1-.21,0-.32,0s-.08,0-.1,0c-.08-.16,0-.37-.06-.55h-.29l-.05-.08.05-.11-.11,0c0,.05,0,.13,0,.19A2.4,2.4,0,0,0,44,43.69a1.54,1.54,0,0,0,.13.18l.11.05Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.31,43.73c.19-.23.48-.31.69-.52a9.14,9.14,0,0,1,1.9-.82.5.5,0,0,0-.08-.42,2,2,0,0,0-.21-.23c-.39.23-.69.65-1.11.81-.16.11-.31.11-.42.18a1.23,1.23,0,0,0-.45.16,4.55,4.55,0,0,1-.61,0h0a1.34,1.34,0,0,0,.13.53c.13.08.08.24.16.31Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.58,43.69l.34-.08s0-.08,0-.11l-.43.05a.11.11,0,0,0,0,.08s.06,0,.11.05",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.76,43.69a0,0,0,0,0,0,0l-.18-.53s-.05-.05-.1,0l-.06.32.08.13Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.87,43.58h.05s0,0,.05-.06l-.08-.21-.61,0-.13.16c0,.05.11.05.19,0s0,0,.08-.05l.43.08s0,.06,0,0",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.3,43.42l1.05,0v-.9a7.05,7.05,0,0,1-1.05,0l0,.9Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.56,43.34c1,0,2.09,0,3,0V42.23c-.89.18-2,.13-2.9.24h-.05Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.34,43.36l.21-.58v-.26h-.37a1.67,1.67,0,0,0,0,.79c0,.05,0,0,0,.05Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.71,43.36s.08,0,.1,0c.14-.24,0-.55.06-.81-.16-.08-.37,0-.55,0v.79c.08.08.26,0,.4.05",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "51.13 43.37 51.29 43.31 51.31 42.47 50.26 42.47 50.29 43.31 51.13 43.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.83,43.26l.95.05,0-.84H48.67l0,.47,0,.32c0,.05.13,0,.16,0",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41,43.24v0l-.18-.4s-.05,0-.08,0,.06.27.13.39.05,0,.11.08Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M29.84,42.68a.18.18,0,0,1,.21-.08,2.21,2.21,0,0,0,.84,0A.33.33,0,0,1,31,42.5s0,0,.05,0a1.74,1.74,0,0,0,1-.84v-.05a8.3,8.3,0,0,0-1.37.16,7.2,7.2,0,0,0-.89.26.1.1,0,0,1-.06,0l0,.11,0,.61Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45,42.52l.21,0s0,0,0,0a.09.09,0,0,0,0-.06s0,0,0,0,0,0-.05,0H44.9a.08.08,0,0,0,0,.14Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "44.16 42.34 44.37 42.37 44.35 42.34 44.16 42.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.63,42.34l.42-.78a8.36,8.36,0,0,0-1.66-.05c-.05,0-.05,0-.08,0v.73c.42.1.89-.11,1.32.08",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.56,42.26l2.53-.06,0-.76-2.93,0c-.05,0,0,0,0,.08a5.73,5.73,0,0,1,.37.71Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.3,42.18l.47,0,.16-.18.16-.1-.53-.76-.21.08s-.05,0-.08.08v.92Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25,42.18a0,0,0,0,0,.05,0s0,0,0,0,.08,0,.11,0,0,0,.05,0,0-.05-.08-.08l-.18.16Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.67,42.1l.87,0c0-.21-.24-.39-.34-.6,0,0,0,0,0,0-.19,0-.29.22-.48.32s-.1.08-.16.13l.11.21Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.91,42h.22c.1-.23.36-.28.52-.47-.08-.16-.21-.34-.31-.53s-.13-.23-.24-.29l-.76.52.55.76Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "27.74 41.97 27.76 41.97 28.13 41.94 28 41.77 27.74 41.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.23,41.94l.37,0v-.73a0,0,0,0,0,0,0l-.53.42c.08.11.18.21.13.34Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.38,41.69l.61-.45s0,0,0,0,0,0-.06-.05l-.47-.63-.64.45a2.51,2.51,0,0,0,.55.77Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29.82,41.63l.4-.63-.5-.55a9.74,9.74,0,0,1,.08,1.19Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.31,41.53a2,2,0,0,0,.61-.11,13.87,13.87,0,0,1,4.75,0c-.77-1.58-1.69-3.09-2.56-4.62a.09.09,0,0,0,0-.05H33c-.08.11-.16.24-.24.37-.61,1.05-1.19,2.11-1.79,3.14a10.52,10.52,0,0,0-.69,1.24Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.07,41.42c.05-1.29,0-2.58,0-3.88l-.56,0a4.39,4.39,0,0,0-.05,1.21c0,.19,0,.35,0,.5,0,.5-.08,1.11.21,1.51Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.58,41.4a7,7,0,0,1,1-.1.09.09,0,0,0,.08,0H45l.1,0,.48,0a2.35,2.35,0,0,0,.39-.72l-.32.08,0,0a.16.16,0,0,0,0,.16v0c-.24.13-.51-.1-.74,0-.08,0-.16,0-.21-.05l-.05-.06.1-.47-.16-.21-.15.1-.16.22a.44.44,0,0,1,.13.36c-.18.24-.55.13-.84.24-.05,0-.08,0-.11-.08l.06-.21L43,40.63l.53.79Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.92,41.37l.68-.55-.53-.74a.08.08,0,0,0-.1,0c-.21.19-.48.32-.66.5a3.66,3.66,0,0,0,.58.79Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.21,41.29l.63-.71-1.69,0s0,0,0,.05v.58a8.53,8.53,0,0,0,.92,0,.31.31,0,0,1,.16,0",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.34,41.26h.47c.11-.15,0-.44,0-.66,0,0,0,0,0,0h-.47l0,.68Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48,41.23l1.77-.05a2.85,2.85,0,0,0,0-.66,17.58,17.58,0,0,0-2.4,0,8.18,8.18,0,0,1,.61.71Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.1,41.18a3.18,3.18,0,0,0,1-.05l0-.63a6.43,6.43,0,0,0-1.05,0Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "26.39 41.08 27.13 40.55 26.58 39.79 25.84 40.34 26.39 41.11 26.39 41.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.3,41l.08-.05s0,0,0-.06a.33.33,0,0,0-.1-.08s0,.13,0,.18Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33,40.87a.24.24,0,0,0,.21-.1.64.64,0,0,1,.13-.18s0-.05.05-.05,0-.08.05-.11.24.16.4.08.13-.19.13-.32a.14.14,0,0,1,0-.08L34,40v-.08a.11.11,0,0,1,.08,0,.17.17,0,0,0,.13-.1l-.1-.29-.18-.24c0-.11.13-.26,0-.39l-.26-.11c-.11,0-.24.16-.37.11l-.11-.3c-.08-.05-.13-.18-.26-.13s-.11.16-.13.21l-.08.16a1,1,0,0,1-.29,0c-.08,0-.18-.05-.24,0s0,.37-.13.53a.67.67,0,0,0-.26.13c0,.05-.08.19,0,.26s.1.13.21.16l.1.16c0,.1-.13.21-.08.34a.21.21,0,0,0,.21.13.37.37,0,0,0,.29,0l.21.13.21.31Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.62,40.76l.66-.48-.48-.63a1.26,1.26,0,0,0-.52.39v.29Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.36,40.74h0l.45-.77-.18-.29c-.11,0-.16.11-.24.13s-.34.21-.48.4l.39.53Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33,40.63s.06,0,.06,0a.55.55,0,0,0,0-.5s0,0,0,0a.79.79,0,0,0-.1.5Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "27.37 40.4 28.08 39.84 27.53 39.1 26.76 39.63 27.34 40.4 27.37 40.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42.07,40.37a6.86,6.86,0,0,1,1.32-.76c-.1-.08-.32,0-.47,0-.66,0-1.3,0-1.93,0v.61c.05.08.15,0,.21.08.31,0,.61-.06.87,0",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.6,40.32v-.66l-.31.18s0,0,0,0l.32.45Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.72,40.32h0a.13.13,0,0,0,0-.19.51.51,0,0,0-.24-.22l-.13,0a.62.62,0,0,0,.29.4s.06,0,.08,0",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.52,40.32l.18,0,0-.68c-.46,0-1,0-1.47,0l0,.61a9.31,9.31,0,0,0,1.21.08",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.17,40.29c.37-.08.79,0,1.18,0a2.77,2.77,0,0,0,0-.66c0-.05,0,0,0-.05l-2.25,0c.21.21.61.23.76.52a1.21,1.21,0,0,0,.32.19",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.29,40.29l.29-.08.13-.3a.38.38,0,0,0-.37.18l-.11.14a.08.08,0,0,0,0,.05Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.67,40.26l2.43,0,0-.68H48.67l-.05.66s0,0,0,0Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.46,40.13l.74-.53a0,0,0,0,0,0,0l-.42-.64-.76.5,0,0Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29.82,39.89l.58-.42s0,0,.05-.08a2.65,2.65,0,0,0-.53-.69h-.13a4.69,4.69,0,0,0-.05,1.19Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33,39.84l.11,0a.86.86,0,0,0,0-.26c-.06.05-.18-.06-.21,0v.21Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.8,39.76a.41.41,0,0,0,.19-.08l0-.08a.34.34,0,0,0-.18-.13l-.24.05s-.11.06-.11.11Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.27,39.68l.31-.21c.08-.08,0-.16-.08-.24a1,1,0,0,0-.29-.21Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.1,39.68h0a2,2,0,0,0,.47-.4V39c0-.27-.21-.4-.26-.58a.08.08,0,0,0-.05,0l-.74.52.52.74Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.21,39.74l.42-.06c0-.05-.08-.1-.1-.1a1.37,1.37,0,0,0-.48-.08s0,0-.05.06v.05Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31,39.65s0,0,.05,0l.21-.39-.37.26a.18.18,0,0,0,.11.16",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.69,39.42a.22.22,0,0,0,0-.26.59.59,0,0,0-.31-.24l0,0c-.06.06,0,.16,0,.22a1.14,1.14,0,0,0,.31.29Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.41,39.42a4.06,4.06,0,0,0,.77-.53l-.45-.63-.76.53.42.63Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.32,39.28a.51.51,0,0,0,.34-.1.38.38,0,0,0,.08-.19s.05,0,0,0-.37,0-.42.19-.05.13,0,.13",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.88,39.26l.74-.5a1.93,1.93,0,0,0-.42-.58l-.71.5a.09.09,0,0,0,0,0l.4.55Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.6,39.28l10.5,0,0-.74c-.42-.08-.89,0-1.32-.08l-.05-.53c-.56,0-1.09,0-1.66,0l-.13.63a.08.08,0,0,1-.08.08c-.31,0-.66,0-1,0a2.84,2.84,0,0,1-1.08-.1l-.06-.5a6.69,6.69,0,0,0-1.66-.08c-.08.1,0,.31,0,.47v.06a.21.21,0,0,1-.13.18A6.29,6.29,0,0,1,42,38.47a.92.92,0,0,1-.05-.53c-.53-.08-1.11,0-1.63-.05-.13.19.06.47-.1.69a5.38,5.38,0,0,1-.93.05,1.82,1.82,0,0,0,0,.53,5.14,5.14,0,0,0,1.29.13",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.68,39.23l.74-.55a3,3,0,0,0-.53-.74,8.58,8.58,0,0,0-.77.61,2.77,2.77,0,0,0,.56.69",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33,39.23l.11,0c.1-.11,0-.34,0-.5h0a.47.47,0,0,0-.15.39.09.09,0,0,1,0,.06Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.36,38.73l.76-.52a2,2,0,0,0-.48-.64l-.74.56.43.6Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.8,38.57l.74-.53a1.49,1.49,0,0,0-.37-.48l-.37.06c-.06,0,0,.15-.11.18s-.24.1-.31.24Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.6,38.57l0,0-.05-.42s0,0,0,0-.16,0-.16.13Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "24.47 38.52 25.23 37.96 25.07 37.75 24.44 37.89 24.44 38.52 24.47 38.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.66,38.49l0,0,.39-.66-.34-.48c-.22.05-.4.29-.61.42a2.18,2.18,0,0,0,.5.74Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.52,38.33H40c.07-.1,0-.29,0-.45s0,0-.08,0a.67.67,0,0,0-.42.34l-.05.1s0,0,0,0",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42.31,38.31h1.4c.08-.18,0-.45.16-.58.58-.26,1.26,0,1.89-.13a.3.3,0,0,1,.24.13c0,.19,0,.35,0,.5a7.34,7.34,0,0,0,1.69,0l0,0,0-.48s.05-.08.1-.1a13.48,13.48,0,0,1,1.5-.06c.21,0,.48,0,.61.08s0,.34.08.5h1l0-.74-1.29-.08a.12.12,0,0,1-.08-.13,2.85,2.85,0,0,0,0-.47A11.26,11.26,0,0,0,48,36.68a.15.15,0,0,0,0,.15.85.85,0,0,1-.08.5,14,14,0,0,1-1.87.05.75.75,0,0,1-.29-.13l-.05-.48A11.74,11.74,0,0,0,44,36.7l-.05.55c-.05.1-.19.1-.24.15a11.37,11.37,0,0,0-1.58,0L42,37.2l0-.45c-.53-.07-1.08,0-1.61,0a3.37,3.37,0,0,0-.05.89c.6.16,1.31-.13,1.89.11l.05.56a.05.05,0,0,0,.05,0",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30,38.28c.16,0,.27-.18.43-.26s.26-.16.34-.3l-.34-.5-.53.08-.08.21c0,.26,0,.58.18.77",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.36,38l.18-.1,0-.21c0-.05-.1,0-.13,0s-.1-.06-.1-.11l0-.19-.45.05c.05.24.26.4.42.61Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "26.74 37.54 26.7 37.57 26.95 37.91 26.97 37.91 27.55 37.47 26.74 37.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.25,37.84l.16-.11c-.06,0-.13,0-.21,0l0,.08Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31,37.57l.63-.47s0,0,0,0l-.87.1c0,.14.13.27.27.4",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.26,37.47,32.5,37a.64.64,0,0,0-.39,0l-.08.08,0,.08.24.29Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29,37.28l.48,0-.21-.45c-.16.06-.24.27-.34.39v.06Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.38,37.26l.53-.06a.81.81,0,0,0-.26-.45,1.11,1.11,0,0,0-.29.5Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.09,35.64l.18-.05a1.83,1.83,0,0,0-.15-.82s0,.08-.06.08c0,.27-.15.58,0,.79Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.8,34.78s.13.1.19.08a.7.7,0,0,0,0-.42l-.71.16a.26.26,0,0,1,0,.08Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.06,34.85l.69-.13.1-.06-.1-.13-.64-.06,0,0,0,.22s0,.13,0,.13",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.09,34.43a.18.18,0,0,0,.1-.05l.08-.74s0-.05,0-.05l-.39,0c-.05,0,0,.13,0,.18a5.6,5.6,0,0,1,.24.64Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.45,28l1.77-.47L24,26.94a9.42,9.42,0,0,0-1.88.61Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M52.84,27.86c.18-.11.26-.32.4-.48s0-.05,0-.05c-.21-.18-.55-.18-.82-.31,0,0,0,0-.05,0l-.24.61Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51.86,27.6s0,0,.05,0l.21-.61a12.26,12.26,0,0,0-1.89-.53,1.67,1.67,0,0,0-.16.72Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.51,27.44l2.16-.5-.13-.66c-.66.13-1.45.31-2.19.5,0,0,0,0-.05,0Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22,27.26,23,27c0-.13-.13-.61-.26-.66l-1.22.28Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.65,27.1h.13l.16-.71a4.45,4.45,0,0,1-1.05-.26,11,11,0,0,1-1.14-.23l-.18.76v.05Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M53.39,27.07h0l.29-.34s0,0,0-.05A8,8,0,0,0,51.6,26l-.16.48Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27,26.89l2.16-.4c.08-.18-.08-.5-.1-.74-.71.18-1.43.29-2.22.42l.11.66,0,.05Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23.3,26.86l2-.53-.16-.69L23,26.2a1.19,1.19,0,0,0,.24.66Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.22,26.65h.05c.13-.16.11-.4.16-.58s.05-.16.05-.22l0,0-2.19-.37-.11.82c.66.15,1.37.21,2.06.37",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29.5,26.43l2.09-.26s0,0,0,0l-.08-.77a19.17,19.17,0,0,0-2.16.29,2.37,2.37,0,0,0,.11.76Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51.12,26.43a.09.09,0,0,0,.05,0l.16-.5a11.88,11.88,0,0,0-2.19-.5l-.13.48c.64.23,1.4.34,2.11.55",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M53.95,26.36h0a1.53,1.53,0,0,0,.37-.53,25.86,25.86,0,0,0-3-1A55.74,55.74,0,0,0,39.39,23c-1-.06-1.95,0-2.93,0-.76,0-1.45,0-2.19.05a52.32,52.32,0,0,0-5.36.58,51.53,51.53,0,0,0-6.73,1.58c-.42.16-.87.34-1.27.48l.4.61A61,61,0,0,1,28,24.69a55.39,55.39,0,0,1,7.68-.82,50.35,50.35,0,0,1,13.58,1.19c.56.11,1.09.27,1.61.39a27.82,27.82,0,0,1,3,.9Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.81,26.28h.08c.1-.21.05-.5.13-.74,0-.05,0-.05,0-.08-.74-.1-1.45-.23-2.19-.29l-.08.84c.61.16,1.37.13,2,.27",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "25.73 26.25 27.95 25.75 27.79 25.04 25.57 25.57 25.7 26.23 25.73 26.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "32.09 26.12 33.99 25.94 33.96 25.15 31.98 25.38 32.09 26.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42.42,26h.05a2.83,2.83,0,0,0,.13-.84,11.92,11.92,0,0,0-2-.19,6.92,6.92,0,0,0-.05.82.09.09,0,0,0,0,0Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.09,25.94l2-.11L36,25l-2,.13.06.79s0,0,0,0",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.13,25.85h.16c.1-.18,0-.47,0-.73,0-.06,0-.06,0-.11L40.29,25s0,0-.05,0l-1.85,0c-.08.18,0,.39-.05.6s0,.16.05.24Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.75,25.85h0l.13-.5a9.94,9.94,0,0,0-2.33-.5l-.13.55Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.35,25.83l1.69,0a1.69,1.69,0,0,0,0-.84H36.3a2.75,2.75,0,0,0,0,.79.09.09,0,0,0,0,.08Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.07,25.7l2.11-.43-.1-.6a17,17,0,0,0-2.16.34l.13.66Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.45,25.62h0l.21-.26c-.45-.21-1-.34-1.45-.55a51.81,51.81,0,0,0-15.14-2.4c-.55,0-1.05,0-1.58,0a20.42,20.42,0,0,0-2.16.11,51.88,51.88,0,0,0-5.75.69,56.84,56.84,0,0,0-7.12,1.71c-.26.13-.55.24-.81.37l.1.16c1.77-.45,3.59-1.08,5.41-1.45.4-.11.8-.16,1.22-.27a51.36,51.36,0,0,1,11-.92A53.82,53.82,0,0,1,48.75,24c1,.29,2.11.52,3.16.79.87.24,1.71.56,2.53.84",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.11,25.38h.08l.1-.55a18.77,18.77,0,0,0-2.08-.32h0l-.05.55Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.47,25.27,32.56,25l-.06-.63a11.46,11.46,0,0,0-2.11.24l.05.66Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.79,25.15a.1.1,0,0,0,.06,0,6,6,0,0,0,.4-.64,13.55,13.55,0,0,0-1.72-.55l-.24.58,0,.11Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.71,25h.1c.13-.13.08-.37.11-.53a16.52,16.52,0,0,0-2.16-.23l-.06.55a13.43,13.43,0,0,1,2,.21",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20.5,25l1.56-.5a.08.08,0,0,1,0-.05l-.29-.63-1.67.56a.17.17,0,0,0,0,.15c.16.16.18.34.34.5Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.87,25l1.82-.16c.16-.16,0-.42.05-.63v0l-1.9.13a2.11,2.11,0,0,0,0,.69Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.06,24.83l1.93-.1v-.61a16.62,16.62,0,0,0-2,.06Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.18,24.83h.24c.1-.19,0-.37.08-.56a0,0,0,0,0,0,0l-1.81-.1a1.35,1.35,0,0,0,0,.58Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.3,24.75h2c.1-.13.05-.4.05-.58a0,0,0,0,1,0,0c-.66-.08-1.37,0-2.06-.06a4.88,4.88,0,0,0,0,.61.06.06,0,0,0,.05.06",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M53,24.51a2.3,2.3,0,0,0,.26-.68,13.9,13.9,0,0,0-1.84-.58l-.13.74,1.69.52Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.37,24.38l1.74-.48-.18-.71a12,12,0,0,0-1.85.5l.27.69Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55.34,24.2a.17.17,0,0,0,.19-.05,3.09,3.09,0,0,0,.45-.74,9,9,0,0,0-1.26-.48l-.45.9Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "20.11 24.09 20.38 23.99 20.01 23.25 19.64 23.38 20.11 24.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.91,23.85s0,.05.05,0l.16-.71a25.64,25.64,0,0,0-2.58-.64,3.34,3.34,0,0,0-.21.77Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "22.38 23.32 22.04 22.59 20.27 23.14 20.64 23.88 22.38 23.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.4,23.83l2-.45a2.22,2.22,0,0,0-.19-.79l-2,.5.21.77Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54,23.78a.11.11,0,0,1,0-.06l.42-.87L54,22.72a3.82,3.82,0,0,0-.4.9Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.76,22.93a.08.08,0,0,0,0,0l-.13-.74a12,12,0,0,0-2.1.37c-.06.11,0,.21,0,.35a2.68,2.68,0,0,1,.1.45,13.47,13.47,0,0,0,2.09-.37",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.9,23.22l.16,0,.18-.77c0-.08-.18,0-.26-.08A17.91,17.91,0,0,0,45.92,22a2.1,2.1,0,0,0-.08.81Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.11,23.2c.18-.13.24-.37.37-.53v-.05l-.58-.16-.24.55Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.34,23.14l1-.34-.24-.55a2.64,2.64,0,0,0-1.05.42l.26.47Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55.32,22.9h0l.14-.1.21-.51a3.4,3.4,0,0,0-1.24-.42,1.7,1.7,0,0,0-.29.61Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "29.27 22.88 31.38 22.56 31.27 21.74 29.11 22.06 29.24 22.88 29.27 22.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.48,22.8h.05l.16-.8a18.83,18.83,0,0,0-2.4-.34c-.13.21-.08.55-.13.81.74.13,1.56.19,2.32.32",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.68,22.74h.05a5.23,5.23,0,0,0,.29-.89,2.83,2.83,0,0,0-1-.29l-.27.92Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "21.93 22.27 21.75 21.69 20.56 22.11 20.77 22.64 21.93 22.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "24.54 21.77 24.75 22.67 24.78 22.67 25.07 22.56 24.86 21.72 24.54 21.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "25.33 22.51 26.84 22.19 26.65 21.27 25.1 21.64 25.31 22.51 25.33 22.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.47,22.51l1.77-.16a2.91,2.91,0,0,0-.05-.84l-1.82.19.08.81Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42.76,22.48h.1a2.83,2.83,0,0,0,.13-.84,21.67,21.67,0,0,0-2.27-.22l-.05.85Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.51,22.46a0,0,0,0,0,0,0l.26-.92a1.55,1.55,0,0,0-.71-.19c-.13.29-.16.63-.27,1Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.56,22.35l2.35-.13V21.4a23.94,23.94,0,0,0-2.42.06l.05.87a0,0,0,0,1,0,0",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.26,22.27h.16c.1-.24,0-.56.08-.82a14.26,14.26,0,0,0-2.16-.13l0,.84c.61.08,1.31,0,2,.11",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.2,22.22,38,22.16v-.82l-1.45,0-.4,0a3,3,0,0,0,0,.87Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.85,21.72h.08l.21-.92a12.36,12.36,0,0,0-2-.34l-.16,1Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29.45,21.67l.42-.08-.11-.92c-.13-.08-.31,0-.47,0a3.5,3.5,0,0,0,.1,1,0,0,0,0,1,0,0Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.18,21.56l1.27-.16c.13-.31-.05-.68-.05-1l-1.32.16a2.08,2.08,0,0,0,.08,1s0,0,0,0",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51,21.56H51l.21-.71-2-.52a2,2,0,0,0-.19.74Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.27,21.51l1.32-.34-.16-.63-1.24.31c-.08.18.06.45.08.66",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.19,21.16l1.16-.08-.05-1c-.13,0-1.14.06-1.14.08v1a0,0,0,0,1,0,0",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.84,21.16h.29l.08-.93a6.69,6.69,0,0,0-1.45-.1v1Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.88,21.11l.55-.08-.21-.73-.48.13a1.67,1.67,0,0,0,.11.69Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.23,21.06v-1c-.16-.06-.4,0-.61,0l0,1,.58,0",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.23,21.09h.22a3,3,0,0,0,.05-1,.51.51,0,0,0-.35,0l0,.89s.08,0,.1.06",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46,20.51h.13a1.47,1.47,0,0,0,.13-.69,6.25,6.25,0,0,0-1-.18l-.1.74Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29.24,20.45l1.29-.21h0l-.08-.63a8.47,8.47,0,0,0-1.32.21l.05.61s0,0,0,0",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.85,20.35H45a2,2,0,0,0,.11-.72c-.18-.13-.5-.08-.74-.13-.11.13-.08.34-.16.53v.19c.16.14.45.08.66.14",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.87,20.21l.5-.08-.11-.64-.47.06a1,1,0,0,0,.05.63Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "40.94 19.95 41.4 19.95 41.45 19.23 40.92 19.13 40.94 19.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.47,19.87l0-.66a3.16,3.16,0,0,0-1.32-.11l-.05.71Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.17,19.93h.32a1.71,1.71,0,0,0,0-.71l-.35,0,0,.74Z",
    transform: "translate(0.19 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "34.96 19.87 36.39 19.84 36.37 19.13 34.94 19.16 34.94 19.87 34.96 19.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.41,57.57l-.09,0h0a2.08,2.08,0,0,1-.17.26,1.3,1.3,0,0,0-.22.37l.08,0a1.33,1.33,0,0,1,.21-.35,2.12,2.12,0,0,0,.17-.26l.07,0a4.31,4.31,0,0,1,1.27-.39v-.09a4.42,4.42,0,0,0-1.3.4",
    transform: "translate(0.19 0)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3f3ec438f8c78d8494932402f49bc064.svg";
export { ForwardRef as ReactComponent };